import React, { useState } from 'react';
import MLDialog from '../../../../MLDialog/MLDialog';
import s from './HowIsThisCalculatedModal.module.css';

function HowIsThisCalculatedModal() {
  const [showModal, setShowModal] = useState(false);

  const handleOpen = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  // Grouped these together up here so it's easy to turn them into props
  // if we eventually need to use this modal in other places
  const title = 'Student Performance Overview';
  const dataTestId = 'individual_student_gb_performance_overview_calculation';
  const content = (
    <div>
      <p>
        <strong>Student Weekly Grade</strong> tracks the student’s total Achieve
        grade at the end of each Course Week. (Course Weeks are determined by
        the “Activate On” date selected in the Course Settings.)
      </p>
      <p>
        <strong>Class Average Grade</strong> tracks the overall class average
        (of all students in the course) at the end of each Course Week. This
        tracking allows you to compare a specific student’s performance to the
        class average.
      </p>
      <p>
        <strong>Below 60%</strong> is a dotted line that shows when the specific
        student or the class average drops below 60%. If the specific student’s
        score drops below 60%, the line graph will appear red as a highlight.
        (The Class Average line does not change color.)
      </p>
    </div>
  );

  return (
    <>
      <button
        className={s.howLink}
        role="link"
        onClick={handleOpen}
        type="button"
        data-test-id={dataTestId}
      >
        How is this calculated?
      </button>
      <MLDialog
        show={showModal}
        onClose={handleClose}
        title={title}
        className={s.modalContainer}
        bodyClassName={s.modalContent}
        titleClassName={s.modalTitleContainer}
        titleTextClassName={s.modalTitle}
      >
        {content}
      </MLDialog>
    </>
  );
}

export default HowIsThisCalculatedModal;
